var SecureBrand;
(function (SecureBrand) {
    SecureBrand["VisaSecure"] = "visa-secure";
    SecureBrand["MccIdCheck"] = "mcc-id-check";
    SecureBrand["SSL"] = "ssl";
    SecureBrand["PCIDss"] = "pci-dss";
    SecureBrand["Norton"] = "norton";
    SecureBrand["McAffee"] = "mc-affee";
})(SecureBrand || (SecureBrand = {}));
export default SecureBrand;
